export { default } from '@shikijs/langs/ini'
